import Box from '@sendsprint/ui-react/dist/components/Box';
import Skeleton from '@sendsprint/ui-react/dist/components/Skeleton';
import { useLoadUserRecurringIntervals } from '@src/hooks/queries/recurring';
import React from 'react';
import ScheduleForm, { TransferScheduleDataI } from './scheduleForm';

export interface TransferScheduleProps {
  formData?: TransferScheduleDataI;
  // eslint-disable-next-line no-unused-vars
  onSubmitSuccess: (value: TransferScheduleDataI) => void;
}

const ScheduleStep = ({ onSubmitSuccess, formData }: TransferScheduleProps) => {
  const { data: recurringIntervals, isLoading: isIntervalsLoading } =
    useLoadUserRecurringIntervals();

  return (
    <>
      {isIntervalsLoading && (
        <Box className="ss-flex ss-items-start ss-gap-8">
          <Box className="ss-space-y-5 ss-flex-1">
            <Skeleton className="ss-h-20 ss-rounded-lg" />
            <Skeleton className="ss-h-[350px] ss-rounded-lg" />
            <Skeleton className="ss-h-20 ss-rounded-lg" />
          </Box>
          <Box className="ss-hidden ss-w-[350px] xl:ss-block" />
        </Box>
      )}
      {!isIntervalsLoading && recurringIntervals && (
        <Box className="ss-flex ss-items-start ss-gap-8">
          <Box className="ss-flex-1">
            <ScheduleForm
              onSubmitSuccess={onSubmitSuccess}
              formData={formData}
              recurringIntervals={recurringIntervals}
            />
          </Box>
          <Box className="ss-hidden ss-w-[350px] xl:ss-block" />
        </Box>
      )}
    </>
  );
};

export default ScheduleStep;
